import { m8API } from 'services/production/m8';
import { normalizeM8PartnerClientDTO } from 'services/production/utils/normalizeM8PartnerClientDTO';
import { GetPartnerTrialClientsTableItemsService } from 'types/services';

export const getPartnerTrialClientsTableItems: GetPartnerTrialClientsTableItemsService = async () => {
  const m8PartnerClients = await m8API.partner.getTrialClients();

  return m8PartnerClients.map((m8PartnerClient) =>
    normalizeM8PartnerClientDTO(m8PartnerClient).toPartnerClientsTableItem()
  );
};
